import { render, staticRenderFns } from "./PolicyUsersByArea.vue?vue&type=template&id=f3a9f548"
import script from "./PolicyUsersByArea.vue?vue&type=script&lang=js"
export * from "./PolicyUsersByArea.vue?vue&type=script&lang=js"
import style0 from "./PolicyUsersByArea.vue?vue&type=style&index=0&id=f3a9f548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports